/**
 * Button.jsx
 * ---------------------------------------------------------------------------
 * Three variants:
 *   primary — navy fill, inverts to accent on hover
 *   ghost   — outlined, fills on hover
 *   subtle  — light border for de-emphasized actions
 *
 * Intentionally square corners (no border-radius) to preserve the
 * institutional feel.
 */

import React from "react";
import { tokens } from "../../lib/tokens.js";

const styles = {
  primary: {
    background: tokens.ink,
    color: "#FFFFFF",
    border: `1px solid ${tokens.ink}`,
  },
  ghost: {
    background: "transparent",
    color: tokens.ink,
    border: `1px solid ${tokens.ink}`,
  },
  subtle: {
    background: "transparent",
    color: tokens.ink,
    border: `1px solid ${tokens.hairline}`,
  },
};

export default function Button({
  children,
  variant = "primary",
  onClick,
  type = "button",
  disabled = false,
}) {
  const base = styles[variant];
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        ...base,
        fontFamily: "'Inter', sans-serif",
        fontSize: 13,
        letterSpacing: "0.04em",
        padding: "16px 28px",
        cursor: disabled ? "not-allowed" : "pointer",
        fontWeight: 500,
        transition: "all 180ms ease",
        borderRadius: 0,
        opacity: disabled ? 0.5 : 1,
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        if (variant === "primary") {
          e.currentTarget.style.background = tokens.accent;
          e.currentTarget.style.borderColor = tokens.accent;
        } else {
          e.currentTarget.style.background = tokens.ink;
          e.currentTarget.style.color = "#fff";
        }
      }}
      onMouseLeave={(e) => {
        Object.assign(e.currentTarget.style, base);
      }}
    >
      {children}
    </button>
  );
}
